<template lang="pug">
grid-container(
  cols="auto",
  cols-md="auto 100px",
  rows="auto 100px",
  rows-md="auto",
  gap="8px"
)
  v-img.product-gallery-widget_main-img(
    :src="files + active",
    :aspect-ratio="1",
    :width="!sm ? '500px' : ''",
    :height="!sm ? '500px' : ''",
    contain
  )
  v-sheet.product-gallery-widget_thumbs.pr-md-1.pb-1.pb-md-0(
    :height="!sm ? '500px' : '100px'"
  )
    v-item-group(v-model="active", mandatory)
      grid-container(
        auto-cols="100px",
        cols-md="auto",
        auto-rows="100px",
        auto-flow="column",
        auto-flow-md="row",
        gap="8px"
      )
        v-item(
          v-for="({ path }, i) in items",
          :key="i",
          :value="path",
          v-slot="{ active, toggle }"
        )
          v-img.product-gallery-widget_thumb(
            v-ripple,
            @click="toggle",
            :class="active && 'product-gallery-widget_thumb-active'",
            :src="files + path",
            :aspect-ratio="1",
            contain
          )
</template>

<script>
export default {
  props: {
    main: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    active: 0,
  }),
  computed: {
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  mounted() {
    this.active = this.main;
  },
};
</script>

<style>
.product-gallery-widget_main-img,
.product-gallery-widget_thumb {
  border: 1px solid #ccc;
  border-radius: 2px;
}
.product-gallery-widget_thumb {
  cursor: pointer;
}
.product-gallery-widget_thumb-active {
  border: 1px solid var(--v-primary-base);
}
.product-gallery-widget_thumbs {
  overflow-y: scroll;
}

.product-gallery-widget_thumbs::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}
.product-gallery-widget_thumbs::-webkit-scrollbar-thumb {
  background: var(--v-secondary-base);
  border-radius: 4px;
}
.product-gallery-widget_thumbs::-webkit-scrollbar-thumb:hover {
  background: var(--v-secondary-darken1);
}
@media screen and (max-width: 960px) {
  .product-gallery-widget_thumbs {
    overflow-y: hidden;
    overflow-x: scroll;
  }
}
</style>
